import React from 'react'
import Box from '@mui/joy/Box'
import Slider, { type SliderProps } from '@mui/joy/Slider'
import Input, { type InputProps } from '@mui/joy/Input'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

import type { MinMaxRange } from '../types'

export default function PriceSlider({
    currency,
    minValue,
    maxValue,
    range,
    handleSlideMinMax,
    handleChange,
}:{
    currency: string,
    minValue: number | null,
    maxValue: number | null,
    range: MinMaxRange | null,
    handleSlideMinMax: SliderProps['onChange'],
    handleChange: InputProps['onChange'],
}) {

    const { t } = useTranslation()

    function valueText(value: number) {
        return `${value} ${currency}`
    }

    const rangeMin = range?.min ?? 0
    const rangeMax = range?.max ?? (currency === 'eur' ? 120 : 3000)

    return (
        <Box>
            <Typography level='title-md'>{t('filters.priceRange')}</Typography>
            <Box px={2.5}>
                <Slider
                    getAriaLabel={() => 'Price range'}
                    value={[minValue ?? rangeMin, maxValue ?? rangeMax]}
                    onChange={handleSlideMinMax}
                    valueLabelDisplay="auto"
                    getAriaValueText={valueText}
                    min={rangeMin}
                    max={rangeMax}
                    step={currency === 'EUR' ? 1 : 10}
                    sx={{
                        "--Slider-thumbSize": "18px"
                    }}
                />
            </Box>
            <Box display="flex" justifyContent="space-between">
                <Input
                    value={minValue ?? ''}
                    placeholder={rangeMin.toString()}
                    variant="outlined"
                    name="minPrice"
                    onChange={handleChange}
                    endDecorator={
                        <Typography color="neutral">{currency}</Typography>
                    }
                    sx={{ width: '140px' }}
                />
                <Input
                    value={maxValue ?? ''}
                    placeholder={rangeMax.toString()}
                    variant="outlined"
                    name="maxPrice"
                    onChange={handleChange}
                    endDecorator={
                        <Typography color="neutral">{currency}</Typography>
                    }
                    sx={{ width: '140px' }}
                />
            </Box>
        </Box>
    )
}